const getLocaleSwitcherMenuTitle = (availableLocales, locale, fallbackLabel) => {
  const selectedLocale = availableLocales.find(
    (item) => item.locale.replace("_", "-") === locale
  );
  return selectedLocale ? selectedLocale.chooseLanguage : fallbackLabel;
};
export {
  getLocaleSwitcherMenuTitle
};
//# sourceMappingURL=get-locale-switcher-menu-title.js.map
